import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {deleteWebhook} from "../../../redux/Actions/webhooks.actions";

export const useWebhooksTableActions = (fetchAfterDelete = () => {}) => {
  const {
    isOpen: isEditModalOpen,
    onOpen: openEditModal,
    onClose: closeEditModal,
  } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: openDeleteModal,
    onClose: closeDeleteModal,
  } = useDisclosure();
  const {
    isOpen: isCustomFieldModalOpen,
    onOpen: openCustomFieldModal,
    onClose: closeCustomFieldModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedRow = () => {
    setSelectedRow(null);
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      setSelectedRow({
        ...data,
        additional_headers: Object.entries(data.additional_headers || {}).map(
          ([key, value]) => ({
            key,
            value,
          })
        ),
      });
      switch (action) {
        case "Delivery_logs":
          navigate(`/app/webhook-delivery-logs/${data.id}`);
          break;
        case "View_Custom_Fields":
          openCustomFieldModal();
          break;
        case "Edit":
          openEditModal();
          break;
        case "Delete":
          openDeleteModal();
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDelete = () => {
    const callback = () => {
      closeDeleteModal();
      clearSelectedRow();
      fetchAfterDelete();
    };
    dispatch(deleteWebhook(selectedRow.id, callback));
  };

  const handleCustomFieldModalClose = () => {
    closeCustomFieldModal();
    clearSelectedRow();
  };

  const handleDeleteModalClose = () => {
    closeDeleteModal();
    clearSelectedRow();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedRow();
  };

  return {
    closeCustomFieldModal: handleCustomFieldModalClose,
    closeDeleteModal: handleDeleteModalClose,
    closeEditModal: handleEditModalClose,
    handleActionSelection,
    handleDelete,
    isCustomFieldModalOpen,
    isDeleteModalOpen,
    isEditModalOpen,
    selectedRow,
  };
};
